<script>
import _ from 'lodash'
import { Doughnut, mixins } from 'vue-chartjs'

const { reactiveProp } = mixins

export default {
  name: 'DonutChartJs',
  extends: Doughnut,
  mixins: [reactiveProp],
  props: ['chartOptions', 'chartInfo', 'chartPlugins', 'chartId', 'chartData'],
  data () {
    return {
      options: _.merge(
        {
          animation: false,
          responsive: true,
          cutoutPercentage: 90,
          maintainAspectRatio: false,
          title: {
            display: false
          },
          legend: {
            display: false
          },
          tooltips: {
            enabled: false
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            }
          },
          onClick: this.handleClick
        },
        this.chartOptions
      )
    }
  },
  methods: {
    renderDonutChart (destroy = true) {
      if (destroy && !_.isNull(this.$data._chart)) {
        this.$data._chart.destroy()
      }
      this.renderChart(this.chartData, this.options)
    },
    setDimensions () {
      this.$el.style.width = `${this.chartOptions.width}px`
      this.$el.style.height = `${this.chartOptions.height}px`
      this.renderDonutChart()
    },
    handleClick (point, event) {
      if (_.isEmpty(event)) {
        return false
      }
      const item = event[0]
      this.$emit('donut-click', {
        value: item._index
      })
    }
  },
  mounted () {
    if (this.chartPlugins) {
      if (_.isArray(this.chartPlugins)) {
        this.chartPlugins.forEach(pluginId => {
          this.addPlugin(pluginId)
        })
      } else {
        this.addPlugin(this.chartPlugins)
      }
    }
    this.setDimensions()
  },
  beforeDestroy () {}
}
</script>



// WEBPACK FOOTER //
// src/components/chart/DonutChartJs.vue